import type { FormField, FormFieldType } from "../types/form-builder";

export interface FormBuilderSample {
  name: string;
  categoryId?: string | null;
  departmentId?: string | null;
  description: string;
  useCase: string;
  targetAudience: string;
  processAfterSubmission: string;
  allowFileAttachment: boolean;
  fields: Omit<FormField, "id">[];
}

export const formBuilderSamples: FormBuilderSample[] = [
  {
    name: "ຟອມສະໝັກວຽກ",
    description: "ຟອມສະໝັກວຽກສໍາລັບຜູ້ສະໝັກວຽກໃໝ່",
    useCase: "ໃຊ້ເພື່ອຮັບສະໝັກວຽກຈາກຜູ້ສະໝັກວຽກ",
    targetAudience: "ຜູ້ສະໝັກວຽກທຸກຄົນ",
    processAfterSubmission: "HR ຈະກວດສອບແລະຕິດຕໍ່ກັບຜູ້ສະໝັກວຽກ",
    allowFileAttachment: true,
    fields: [
      {
        type: "text" as FormFieldType,
        label: "ຊື່-ນາມສະກຸນ",
        required: true,
        placeholder: "ຕົວຢ່າງ: ທ້າວ ສຸກສະຫວັນ ພົມມະສານ",
        order: 0,
        config: {},
      },
      {
        type: "email" as FormFieldType,
        label: "ອີເມວ",
        required: true,
        placeholder: "example@email.com",
        order: 1,
        config: {},
      },
      {
        type: "phone" as FormFieldType,
        label: "ເບີໂທ",
        required: true,
        placeholder: "020 12345678",
        order: 2,
        config: {},
      },
      {
        type: "date" as FormFieldType,
        label: "ວັນເດືອນປີເກີດ",
        required: true,
        order: 3,
        config: {},
      },
      {
        type: "textarea" as FormFieldType,
        label: "ປະຫວັດການສຶກສາ",
        required: false,
        placeholder: "ລາຍລະອຽດການສຶກສາ",
        order: 4,
        config: {},
      },
      {
        type: "textarea" as FormFieldType,
        label: "ປະສົບການເຮັດວຽກ",
        required: false,
        placeholder: "ລາຍລະອຽດປະສົບການ",
        order: 5,
        config: {},
      },
      {
        type: "file" as FormFieldType,
        label: "ແນບຟາຍ Resume",
        required: true,
        order: 6,
        config: { accept: ".pdf,.doc,.docx" },
      },
    ],
  },
  {
    name: "ຟອມລາຍງານບັນຫາ",
    description: "ຟອມສໍາລັບລາຍງານບັນຫາຫຼືຂໍ້ບົກພ່ອງ",
    useCase: "ໃຊ້ເພື່ອລາຍງານບັນຫາຕ່າງໆ ໃນອົງກອນ",
    targetAudience: "ພະນັກງານທຸກຄົນ",
    processAfterSubmission: "ຜູ້ບໍລິຫານຈະເບິ່ງແລະແກ້ໄຂບັນຫາ",
    allowFileAttachment: true,
    fields: [
      {
        type: "text" as FormFieldType,
        label: "ຫົວຂໍ້ບັນຫາ",
        required: true,
        placeholder: "ລາຍລະອຽດຫົວຂໍ້ບັນຫາ",
        order: 0,
        config: {},
      },
      {
        type: "select" as FormFieldType,
        label: "ປະເພດບັນຫາ",
        required: true,
        placeholder: "ເລືອກປະເພດ",
        order: 1,
        config: {
          options: [
            { label: "ບັນຫາອຸປະກອນ", value: "equipment" },
            { label: "ບັນຫາສິ່ງແວດລ້ອມ", value: "environment" },
            { label: "ບັນຫາຄົນ", value: "personnel" },
            { label: "ອື່ນໆ", value: "other" },
          ],
        },
      },
      {
        type: "textarea" as FormFieldType,
        label: "ລາຍລະອຽດບັນຫາ",
        required: true,
        placeholder: "ອະທິບາຍບັນຫາໃຫ້ລາຍລະອຽດ",
        order: 2,
        config: {},
      },
      {
        type: "date" as FormFieldType,
        label: "ວັນທີເກີດບັນຫາ",
        required: true,
        order: 3,
        config: {},
      },
      {
        type: "file" as FormFieldType,
        label: "ຮູບພາບ/ແນບຟາຍ",
        required: false,
        order: 4,
        config: { accept: "image/*,.pdf" },
      },
    ],
  },
  {
    name: "ຟອມຂໍອະນຸຍາດລາພັກ",
    description: "ຟອມສໍາລັບຂໍອະນຸຍາດລາພັກ",
    useCase: "ໃຊ້ເພື່ອຂໍອະນຸຍາດລາພັກຈາກຜູ້ບໍລິຫານ",
    targetAudience: "ພະນັກງານ",
    processAfterSubmission: "ຜູ້ບໍລິຫານຈະພິຈາລະນາແລະອະນຸຍາດ",
    allowFileAttachment: false,
    fields: [
      {
        type: "text" as FormFieldType,
        label: "ຊື່ພະນັກງານ",
        required: true,
        placeholder: "ຊື່-ນາມສະກຸນ",
        order: 0,
        config: {},
      },
      {
        type: "date" as FormFieldType,
        label: "ວັນທີເລີ່ມລາພັກ",
        required: true,
        order: 1,
        config: {},
      },
      {
        type: "date" as FormFieldType,
        label: "ວັນທີສິ້ນສຸດລາພັກ",
        required: true,
        order: 2,
        config: {},
      },
      {
        type: "number" as FormFieldType,
        label: "ຈຳນວນວັນ",
        required: true,
        placeholder: "0",
        order: 3,
        config: { min: 1 },
      },
      {
        type: "select" as FormFieldType,
        label: "ປະເພດລາພັກ",
        required: true,
        placeholder: "ເລືອກປະເພດ",
        order: 4,
        config: {
          options: [
            { label: "ລາພັກປົກກະຕິ", value: "normal" },
            { label: "ລາພັກພັກຜ່ອນ", value: "sick" },
            { label: "ລາພັກສ່ວນຕົວ", value: "personal" },
            { label: "ລາພັກພັກຜ່ອນພັນ", value: "maternity" },
          ],
        },
      },
      {
        type: "textarea" as FormFieldType,
        label: "ເຫດຜົນ",
        required: false,
        placeholder: "ອະທິບາຍເຫດຜົນ",
        order: 5,
        config: {},
      },
    ],
  },
  {
    name: "ຟອມສະໝັກອົບຮົມ",
    description: "ຟອມສໍາລັບສະໝັກອົບຮົມພາຍໃນ",
    useCase: "ໃຊ້ເພື່ອສະໝັກອົບຮົມຕ່າງໆ",
    targetAudience: "ພະນັກງານ",
    processAfterSubmission: "HR ຈະຈັດການອົບຮົມ",
    allowFileAttachment: false,
    fields: [
      {
        type: "text" as FormFieldType,
        label: "ຊື່ພະນັກງານ",
        required: true,
        placeholder: "ຊື່-ນາມສະກຸນ",
        order: 0,
        config: {},
      },
      {
        type: "text" as FormFieldType,
        label: "ຕໍາແໜ່ງ",
        required: true,
        placeholder: "ຕໍາແໜ່ງປັດຈຸບັນ",
        order: 1,
        config: {},
      },
      {
        type: "text" as FormFieldType,
        label: "ຫົວຂໍ້ອົບຮົມ",
        required: true,
        placeholder: "ຊື່ຫົວຂໍ້ອົບຮົມ",
        order: 2,
        config: {},
      },
      {
        type: "textarea" as FormFieldType,
        label: "ເຫດຜົນທີ່ຕ້ອງການອົບຮົມ",
        required: true,
        placeholder: "ອະທິບາຍເຫດຜົນ",
        order: 3,
        config: {},
      },
      {
        type: "date" as FormFieldType,
        label: "ວັນທີທີ່ຕ້ອງການ",
        required: false,
        order: 4,
        config: {},
      },
    ],
  },
  {
    name: "ຟອມຂໍອຸປະກອນ",
    description: "ຟອມສໍາລັບຂໍອຸປະກອນຫຼືວັດສະດຸ",
    useCase: "ໃຊ້ເພື່ອຂໍອຸປະກອນຈາກພະແນກ IT ຫຼື ການຈັດການ",
    targetAudience: "ພະນັກງານ",
    processAfterSubmission: "ພະແນກທີ່ກ່ຽວຂ້ອງຈະພິຈາລະນາ",
    allowFileAttachment: false,
    fields: [
      {
        type: "text" as FormFieldType,
        label: "ຊື່ພະນັກງານ",
        required: true,
        placeholder: "ຊື່-ນາມສະກຸນ",
        order: 0,
        config: {},
      },
      {
        type: "text" as FormFieldType,
        label: "ຊື່ອຸປະກອນ",
        required: true,
        placeholder: "ຕົວຢ່າງ: ໂນດບຸກ, ເມົາ, ກະໂປງ",
        order: 1,
        config: {},
      },
      {
        type: "number" as FormFieldType,
        label: "ຈຳນວນ",
        required: true,
        placeholder: "1",
        order: 2,
        config: { min: 1 },
      },
      {
        type: "textarea" as FormFieldType,
        label: "ເຫດຜົນ",
        required: true,
        placeholder: "ອະທິບາຍເຫດຜົນທີ່ຕ້ອງການ",
        order: 3,
        config: {},
      },
      {
        type: "date" as FormFieldType,
        label: "ວັນທີທີ່ຕ້ອງການ",
        required: false,
        order: 4,
        config: {},
      },
    ],
  },
  {
    name: "ຟອມລາຍງານການຂາຍ",
    description: "ຟອມສໍາລັບລາຍງານການຂາຍປະຈໍາວັນ",
    useCase: "ໃຊ້ເພື່ອລາຍງານການຂາຍປະຈໍາວັນ",
    targetAudience: "ພະນັກງານຂາຍ",
    processAfterSubmission: "ຜູ້ບໍລິຫານຈະກວດສອບ",
    allowFileAttachment: false,
    fields: [
      {
        type: "date" as FormFieldType,
        label: "ວັນທີ",
        required: true,
        order: 0,
        config: {},
      },
      {
        type: "text" as FormFieldType,
        label: "ຊື່ລູກຄ້າ",
        required: true,
        placeholder: "ຊື່ລູກຄ້າ",
        order: 1,
        config: {},
      },
      {
        type: "phone" as FormFieldType,
        label: "ເບີໂທລູກຄ້າ",
        required: false,
        placeholder: "020 12345678",
        order: 2,
        config: {},
      },
      {
        type: "text" as FormFieldType,
        label: "ຊື່ສິນຄ້າ",
        required: true,
        placeholder: "ຊື່ສິນຄ້າທີ່ຂາຍ",
        order: 3,
        config: {},
      },
      {
        type: "number" as FormFieldType,
        label: "ຈຳນວນ",
        required: true,
        placeholder: "0",
        order: 4,
        config: { min: 1 },
      },
      {
        type: "money" as FormFieldType,
        label: "ລາຄາລວມ",
        required: true,
        placeholder: "0",
        order: 5,
        config: { min: 0 },
      },
    ],
  },
  {
    name: "ຟອມຂໍອະນຸມັດເງິນ",
    description: "ຟອມສໍາລັບຂໍອະນຸມັດເງິນຈ່າຍ",
    useCase: "ໃຊ້ເພື່ອຂໍອະນຸມັດເງິນຈ່າຍຕ່າງໆ",
    targetAudience: "ພະນັກງານ",
    processAfterSubmission: "ຜູ້ບໍລິຫານຈະພິຈາລະນາແລະອະນຸມັດ",
    allowFileAttachment: true,
    fields: [
      {
        type: "text" as FormFieldType,
        label: "ຊື່ພະນັກງານ",
        required: true,
        placeholder: "ຊື່-ນາມສະກຸນ",
        order: 0,
        config: {},
      },
      {
        type: "text" as FormFieldType,
        label: "ຫົວຂໍ້",
        required: true,
        placeholder: "ຫົວຂໍ້ການຂໍອະນຸມັດ",
        order: 1,
        config: {},
      },
      {
        type: "money" as FormFieldType,
        label: "ຈຳນວນເງິນ",
        required: true,
        placeholder: "0",
        order: 2,
        config: { min: 0 },
      },
      {
        type: "textarea" as FormFieldType,
        label: "ເຫດຜົນ",
        required: true,
        placeholder: "ອະທິບາຍເຫດຜົນການໃຊ້ຈ່າຍ",
        order: 3,
        config: {},
      },
      {
        type: "date" as FormFieldType,
        label: "ວັນທີທີ່ຕ້ອງການ",
        required: true,
        order: 4,
        config: {},
      },
      {
        type: "file" as FormFieldType,
        label: "ແນບຟາຍອ້າງອີງ",
        required: false,
        order: 5,
        config: { accept: ".pdf,.jpg,.png" },
      },
    ],
  },
  {
    name: "ຟອມປະເມີນຜົນການເຮັດວຽກ",
    description: "ຟອມສໍາລັບປະເມີນຜົນການເຮັດວຽກປະຈໍາເດືອນ",
    useCase: "ໃຊ້ເພື່ອປະເມີນຜົນການເຮັດວຽກຂອງພະນັກງານ",
    targetAudience: "ຜູ້ບໍລິຫານ",
    processAfterSubmission: "HR ຈະຈັດການປະເມີນຜົນ",
    allowFileAttachment: false,
    fields: [
      {
        type: "text" as FormFieldType,
        label: "ຊື່ພະນັກງານ",
        required: true,
        placeholder: "ຊື່-ນາມສະກຸນ",
        order: 0,
        config: {},
      },
      {
        type: "text" as FormFieldType,
        label: "ຕໍາແໜ່ງ",
        required: true,
        placeholder: "ຕໍາແໜ່ງ",
        order: 1,
        config: {},
      },
      {
        type: "date" as FormFieldType,
        label: "ເດືອນທີ່ປະເມີນ",
        required: true,
        order: 2,
        config: {},
      },
      {
        type: "number" as FormFieldType,
        label: "ຄະແນນ (1-5)",
        required: true,
        placeholder: "0",
        order: 3,
        config: { min: 1, max: 5 },
      },
      {
        type: "textarea" as FormFieldType,
        label: "ຄຳຄິດເຫັນ",
        required: false,
        placeholder: "ຄຳຄິດເຫັນການປະເມີນ",
        order: 4,
        config: {},
      },
      {
        type: "select" as FormFieldType,
        label: "ສະຖານະ",
        required: true,
        placeholder: "ເລືອກສະຖານະ",
        order: 5,
        config: {
          options: [
            { label: "ດີເລີຍ", value: "excellent" },
            { label: "ດີ", value: "good" },
            { label: "ປານກາງ", value: "average" },
            { label: "ຕ້ອງປັບປຸງ", value: "needs_improvement" },
          ],
        },
      },
    ],
  },
];
